'use client'
import { useHookstate } from '@hookstate/core';
import { usePathname } from 'next/navigation';
import { headerState } from '~/store/States/renewal';
import '~/sass/layout/_header.scss';

export default function UI() {
  const header = useHookstate(headerState);
  const pathname = usePathname();
  return (
    <h1 style={{ margin: '0' }}>
      {pathname === '/checkout/purchase-limit' ? 'Información importante' : header.value}
    </h1>
  );
}
